import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="border-t border-paper-line bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="bonos" data-id="element-21" data-mp="pm29dppob3dv">
      <div className="mx-auto max-w-6xl" data-id="element-22" data-mp="ftwikjb5qs09">
        <Reveal data-id="element-23" data-mp="fslgqp19vubs">
          <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-24" data-mp="fs3dh8g70fud">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="5w0c44t60l8h" />
            Incluidos hoy sin costo extra
          </p>
          <h2 id="bonos" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-26" data-mp="3o1v84n1sa6su">
            5 bonos especializados en fútbol
          </h2>
          <p className="mt-6 max-w-readable text-lg text-ink-soft" data-id="element-27" data-mp="1mai563jdm8zf">
            Valor real $235.000 — hoy completamente gratis con el megapack.
          </p>
        </Reveal>

        <ol className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-28" data-mp="1r6z0bhoztnm0">
          {bonuses.map((bonus, i) => <Reveal key={bonus.name} delay={i * 0.04} className="h-full" data-id="element-29" data-mp="3dfd5ls9xsgx3" data-mpi={i}>
              <li className="flex h-full flex-col" data-id="element-30" data-mp="3dd8zd3okf5tn">
                <img src={bonus.cover} alt={bonus.alt} loading="lazy" className="aspect-square w-full rounded-xl border border-paper-line object-cover shadow-lg" data-id="element-31" data-mp="3r702nubpdtgx" />
                <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-ink-dim" data-id="element-32" data-mp="2zhf0zelf3yus">
                  Bono 0{i + 1}
                  <span className="ml-2 text-grass" data-id="element-33" data-mp="38gilmn08gmbe">{bonus.value} · gratis</span>
                </p>
                <h3 className="mt-2 text-lg font-bold leading-snug text-ink" data-id="element-34" data-mp="33gw80cght422">
                  {bonus.name}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-35" data-mp="nogfh67vtdsz">
                  {bonus.body}
                </p>
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}